// extracted by mini-css-extract-plugin
export default {"root":"IconFacebook_root__fcA6K"};